import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import { AnyAction } from 'redux';

import { AbilityRoute } from 'common/ability/ability-route';
import { Subject } from 'common/ability/subject';
import { AbilityAwareProps, withAbilityContext } from 'common/ability/with-ability-context';
import { SubscriptionType } from 'common/constants/subscription';
import { RequestStatus } from 'common/enums/request-status';
import { State as ReduxState } from 'common/interfaces/state';
import { ProfileForm } from 'unit-account/components/profile-dialog/page';
import { NotFoundPage } from 'unit-error-pages/pages';
import { AccountActions } from '../units/account/actions/creators';
import { ProductsPageWrapper } from '../units/products';
import * as Admin from './admin';
import { AppUrls } from './app-urls';
import * as Company from './company';
import * as Subscription from './own-company-subscription';


interface StateProps {
  initialAppDataStatus: RequestStatus;
}

interface DispatchProps {
  getInitialAppData: () => void;
}

interface Props extends StateProps, DispatchProps, AbilityAwareProps, RouteComponentProps<{}> { }


class AppRoutesComponent extends React.Component<Props> {
  public componentDidMount(): void {
    this.props.getInitialAppData();
  }

  public render(): React.ReactNode {
    const subscriptionLandingPath = AppUrls.subscription.index.url({ type: SubscriptionType.Modular });

    return (
      <Switch>
        <Route
          path={AppUrls.account.manage.path}
          component={ProfileForm}
        />
        <Redirect
          exact={true}
          from='/'
          to={{
            pathname: subscriptionLandingPath,
            search: this.props.location.search,
          }}
        />
        <Route exact={true} path={AppUrls.products.path} component={ProductsPageWrapper} />
        <Route path={AppUrls.subscription.index.path} component={Subscription.Routes} />
        <Route path={AppUrls.company.index.path} component={Company.Routes} />
        <AbilityRoute
          subject={Subject.AdminPanel}
          path={AppUrls.admin.index.path}
          component={Admin.Routes}
        />
        <NotFoundPage />;
      </Switch>
    );
  }
}

function mapStateToProps(state: ReduxState): StateProps {
  return {
    initialAppDataStatus: state.account.initialAppDataStatus,
  };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>): DispatchProps {
  return {
    getInitialAppData: () => dispatch(AccountActions.getInitialAppData()),
  };
}

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export const AppRoutes = withRouter(withAbilityContext(withRedux(AppRoutesComponent)));
